import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { useApi, useToaster } from '@shopexperts/shared';

export function useSetReviewShortTextVisibility() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['admin', 'reviewShortTextVisibility'],
    mutationFn: ({ reviewId, keepPublic }: { reviewId: number; keepPublic: boolean }) =>
      api.admin.reviewsV2.setShortTextVisibility({
        params: { review: reviewId },
        body: { short_text_grandfathered: keepPublic },
      }),
    onSuccess: (_review, { keepPublic }) => {
      toaster.create({
        title: keepPublic ? 'Review text kept public' : 'Short review text hidden again',
        type: 'success',
      });
    },
    onError: (error: any) => {
      toaster.create({
        title: 'Could not update review visibility',
        description: error?.response?.data?.message || error?.message || 'Please try again.',
        type: 'error',
      });
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['admin', 'reviews'] }),
  });
}
